export const defaultContent = {
  hotspots: [{}],
}
export const popoverHeadingStyleOptions = [
  {
    value: 'default',
    label: 'All Caps'
  },
  {
    value: 'brackets',
    label: 'All Caps with Brackets in Accent Color'
  },
  {
    value: 'numbered',
    label: 'All Caps with Numbers in Accent Color'
  },
  {
    value: 'standard',
    label: 'Standard'
  }
]

export const popoverBgPatternOptions = [
  {
    value: 'none',
    label: 'None'
  },
  {
    value: 'wavy',
    label: 'Wavy Lines'
  },
  {
    value: 'lines',
    label: 'Diagonal Lines'
  },
  {
    value: 'dots',
    label: 'Dots'
  }
]

export const applyAccentColorOptions = [
  {
    value: 'global',
    label: 'Use same color for all popovers'
  },
  {
    value: 'individual',
    label: 'Set color individually for each popover'
  }
]

export const accentColors = [
  {
    name: 'black',
    label: 'Black',
    hex: '#2d3338',
  },
  {
    name: 'navy',
    label: 'Navy',
    hex: '#22265e',
  },
  {
    name: 'red',
    label: 'Red',
    hex: '#D8214C'
  },
  {
    name: 'orange',
    label: 'Orange',
    hex: '#D64309'
  },
  {
    name: 'green',
    label: 'Green',
    hex: '#26A957'
  },
  {
    name: 'blue',
    label: 'Blue',
    hex: '#0A78D1'
  },
  {
    name: 'purple',
    label: 'Purple',
    hex: '#AE4DA5'
  },
]

export const popoverHeadingSizeOptions = [
  {
    value: 'lg',
    label: 'Large'
  },
  {
    value: 'md',
    label: 'Medium'
  },
  {
    value: 'sm',
    label: 'Small'
  },
]

export const popoverHeadingColors = [
  {
    name: 'black',
    label: 'Black',
    hex: '#2d3338',
  },
  {
    name: 'navy',
    label: 'Navy',
    hex: '#22265e',
  }
]